import React from 'react';
import MerxandatgeRevenueChart from './MerxandatgeRevenueChart';
import BestSellers from './BestSellers';
import './MerxandatgeStats.css';

function MerxandatgeStats({ socket, orders, itemImages, deletedItemIds = new Set(), items = [], deletedItems = [], loading = false }) {
  if (loading) {
    return (
      <div className="merxandatge-stats-container">
        {/* Revenue Chart Skeleton */}
        <div className="merxandatge-stats-skeleton-section">
          <div className="merxandatge-stats-skeleton-header">
            <div className="merxandatge-stats-skeleton-title" />
            <div className="merxandatge-stats-skeleton-total" />
          </div>
          <div className="merxandatge-stats-skeleton-select" />
          <div className="merxandatge-stats-skeleton-chart" />
        </div>
        
        {/* Best Sellers Skeleton */}
        <div className="merxandatge-stats-skeleton-section">
          <div className="merxandatge-stats-skeleton-header">
            <div className="merxandatge-stats-skeleton-title" />
            <div className="merxandatge-stats-skeleton-filter" />
          </div>
          <div className="merxandatge-stats-skeleton-scroll">
            {[1, 2, 3].map((i) => (
              <div key={i} className="merxandatge-stats-skeleton-card">
                <div className="merxandatge-stats-skeleton-card-image" />
                <div className="merxandatge-stats-skeleton-card-info">
                  <div className="merxandatge-stats-skeleton-card-name" />
                  <div className="merxandatge-stats-skeleton-card-metrics" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="merxandatge-stats-container">
      <MerxandatgeRevenueChart orders={orders} breakdownByItems={true} title="Ingressos per ítem mensuals" deletedItemIds={deletedItemIds} />
      <BestSellers socket={socket} itemImages={itemImages} deletedItemIds={deletedItemIds} items={items} deletedItems={deletedItems} />
    </div>
  );
}

export default MerxandatgeStats;

